import type { ReactNode } from 'react';
import { Navbar } from './Navbar';
import { LaunchBanner } from './LaunchBanner';
import { useTheme } from './ThemeProvider';

export function Layout({ children }: { children: ReactNode }) {
  const { mode } = useTheme();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Ambient glow effects */}
      <div
        className="ambient-glow"
        aria-hidden="true"
        style={{
          position: 'fixed',
          top: '-20%',
          right: '-10%',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: mode === 'light'
            ? 'radial-gradient(circle, rgba(255, 140, 66, 0.08) 0%, transparent 70%)'
            : 'radial-gradient(circle, rgba(255, 140, 66, 0.04) 0%, transparent 70%)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
      <div
        className="ambient-glow"
        aria-hidden="true"
        style={{
          position: 'fixed',
          bottom: '-20%',
          left: '-10%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: mode === 'light'
            ? 'radial-gradient(circle, rgba(255, 107, 53, 0.06) 0%, transparent 70%)'
            : 'radial-gradient(circle, rgba(255, 107, 53, 0.03) 0%, transparent 70%)',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      <LaunchBanner />
      <Navbar />

      <main
        style={{
          flex: 1,
          position: 'relative',
          zIndex: 1,
          padding: '32px 24px',
          maxWidth: '1100px',
          margin: '0 auto',
          width: '100%',
        }}
      >
        {children}
      </main>

      <div style={{ display: 'flex', gap: '18px', justifyContent: 'center', padding: '24px 16px', fontSize: '12px' }}>
        <a href="/terms" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Terms</a>
        <a href="/privacy" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Privacy</a>
        <a href="/dmca" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>DMCA</a>
        <a href="/compare" style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>Compare</a>
      </div>
    </div>
  );
}
